import { GridHeaderComponent } from './data-widgets/grid-header.component';
import { PercentDataComponent } from './data-widgets/percent-data.component';
import { RankDataComponent } from './data-widgets/rank-data.component';
import { SellerNameComponent } from './data-widgets/seller-name.component';
import { ReportConfig } from './REPORT_CONFIG';
import { CTV_OPTIONS } from './REPORT_CONFIG_CONST';

export const REPORT_CONFIG_SELLER_MARKET_SHARE: ReportConfig = {
  key: 'seller-market-share',
  heading: 'Market Share',
  title: 'Market Share',
  formTitle: 'Seller Market Share rankings',
  pageTitle: 'Market Share for SSP’s, a Pixalate Rankings index: for {type}',
  pageMeta:
    'Seller Market Share measures estimated market reach for {type} in the {platformName}.',
  reportId: 'sellerMarketShare',
  permissions: ['mrtSellerTrustIndex', 'freemium', 'anonymous'],
  rowLimit: 10,
  fadeStart: 5,
  mainFilterItems: [
    {
      key: 'platformName',
      label: 'OS',
      selected: {
        label:
          '<img class="mr-2" src="/assets/images/google-play.svg" alt="Google Play Icon"/> Google Play',
        value: 'android'
      },
      groups: ['app'],
      hidden: false,
      type: 'toggle-filter',
      options: [
        {
          label:
            '<img class="mr-2" src="/assets/images/google-play.svg" alt="Google Play Icon"/> Google Play',
          value: 'android'
        },
        {
          label:
            '<img class="mr-2" src="/assets/images/apple.svg" alt="App Store Icon"/> App Store',
          value: 'ios'
        }
      ]
    },
    {
      key: 'platformName',
      label: 'OS',
      selected: CTV_OPTIONS[0],
      groups: ['ctv'],
      hidden: false,
      type: 'toggle-filter',
      options: [...CTV_OPTIONS]
    },
    {
      key: 'category',
      label: 'Category',
      selected: { label: 'All Categories', value: 'GLOBAL' },
      groups: ['app', 'ctv'],
      hidden: false,
      dependencies: [
        {
          key: 'countryCode'
        },
        {
          key: 'date'
        },
        {
          key: 'platformName'
        }
      ],
      options: [{ label: 'All Categories', value: 'GLOBAL' }],
      default: { label: 'All Categories', value: 'GLOBAL' }
    },
    {
      key: 'countryCode',
      label: 'Region',
      selected: { label: 'North America', value: 'NA' },
      hidden: false,
      dependencies: [
        {
          key: 'platformName'
        },
        {
          key: 'date'
        }
      ],
      options: [{ label: 'North America', value: 'NA' }],
      default: { label: 'North America', value: 'NA' }
    },
    {
      key: 'countryCode',
      label: 'Country',
      selected: { label: 'All Countries', value: 'GLOBAL' },
      hidden: false,
      dependencies: [
        {
          key: 'date'
        },
        {
          key: 'platformName'
        },
        {
          label: 'Region'
        }
      ],
      options: [{ label: 'All Countries', value: 'GLOBAL' }],
      default: { label: 'All Countries', value: 'GLOBAL' }
    },
    {
      key: 'date',
      label: 'Month',
      selected: null,
      hidden: false,
      dependencies: [
        {
          group: 'app',
          key: 'platformName'
        }
      ],
      options: []
    }
  ],
  gridHeaders: [
    {
      label: 'Rank',
      key: 'impressionRank',
      sort: '',
      sortDefault: false,
      sortColumnKey: '',
      hoverKey: '',
      template: null,
      widgetComponent: RankDataComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'Seller',
      key: 'sellerName',
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      groups: ['app', 'ctv'],
      hoverKey: '',
      template: null,
      widgetComponent: SellerNameComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'Seller',
      key: 'sellerName',
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      groups: ['domain'],
      hoverKey: '',
      template: null,
      widgetComponent: SellerNameComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'Estimated Market Reach',
      key: 'impressionSov',
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: PercentDataComponent,
      hidden: false,
      lockIfAnonymous: true,
      lockIfFreemium: true,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'Spacer',
      key: 'spacer',
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: null,
      hidden: false,
      format: '50%',
      headerWidgetComponent: GridHeaderComponent
    }
  ]
};
